import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { exec, isRequestSuccessed, rst } = useRequest({
    url: '',
    name: 'DELETE_MATERIAL_RECORDS',
    method: 'DELETE',
  });

  useEffect(() => {
    if (param) {
      exec(`/api/material/records?id=${param.id}&type=${param.type}`)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [rst, isRequestSuccessed];
});
